module.exports = __webpack_public_path__ + "fbbcf9e4faa52ad4146d9bb777a150d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/30.jpg
// module id = 1358
// module chunks = 47